import React from 'react';
import { withRouter } from 'react-router-dom';

import AdBanner from '../AdBanner/AdBanner';
import { Title } from '../StyledComponents/Title';
import { AuthorAndTime } from '../StyledComponents/AuthorAndTime';
import { ListElement } from '../StyledComponents/ListElement';
import { rootConfig } from '../../../config/config';
import { StyledLine, StyledLineInside } from '../StyledComponents/StyledLine';
import { CardHolder, Image } from '../StyledComponents';
import adLinkedin from '../../../assets/images/ad-linkedin.png';
import adAmazon from '../../../assets/images/ad-amazon.png';
import adAmazonVertical from '../../../assets/images/ad-amazon-vertical.png';
import adSuggestedVertical from '../../../assets/images/ad-suggested-vertical.png';
import MainListLoader from '../Loaders/MainListLoader';
import {
  SideBarCard,
  SideBarCardData,
  SideBar
} from '../StyledComponents/StyledSideBar';

const sideBar = props => {
  // console.log('props: ', props);
  const { topNewsData } = props;

  const navigate = postSlug => {
    // console.log('props: ', props);
    // console.log('postSlug: ', postSlug);
    props.history.push({ pathname: `/${postSlug}`, state: `change` });
    // console.log('props: ', props);
  };

  let cards = null;
  if (topNewsData !== null) {
    cards = topNewsData.map(news => {
      return (
        <SideBarCard key={news.id} onClick={() => navigate(news.postSlug)}>
          <div className="ImageDiv">
            <div
              style={{
                // width: '225px',
                width: '100%',
                height: '112.5px',
                // background: `url(${rootConfig.imagesRoot}/${
                //   news.featuredImage.file
                // })`,
                background: `${
                  news.featuredImage
                    ? `url(${rootConfig.imagesRoot}/${news.featuredImage.file})`
                    : 'black'
                }`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            />
            {/* <img
              src={
                news.featuredImage
                  ? `${rootConfig.imagesRoot}/${news.featuredImage.file}`
                  : null
              }
              alt={news.postSlug}
            /> */}
          </div>
          <SideBarCardData>
            <Title
              fontFamily="Nunito"
              fontSize="1rem"
              fontWeight="bold"
              lineHeight="1.4"
              padding="0.5rem 0 0 0"
            >
              {news.postTitle}
            </Title>
            <AuthorAndTime
              color="#757575"
              fontFamily="Montserrat"
              fontSize="0.75rem"
              fontWeight="normal"
            >
              <div>{news.postAuthor.authorName}</div>
              <div>{news.postDate}</div>
            </AuthorAndTime>
          </SideBarCardData>
        </SideBarCard>
      );
    });
  }

  return (
    <SideBar>
      <AdBanner height="250px" width="300px" margin="0 0 14px 0">
        <Image src={adLinkedin} width="100%" height="100%" alt="tissot ad" />
      </AdBanner>
      <ListElement className="w-100" padding="1rem">
        <Title fontFamily="Montserrat" fontSize="1.5rem" fontWeight="bold">
          Top News
        </Title>
        <StyledLine>
          <StyledLineInside />
        </StyledLine>
        <CardHolder> {cards !== null ? cards : <MainListLoader />} </CardHolder>
      </ListElement>
      <AdBanner height="250px" width="300px" margin="18px 0 18px 0">
        <Image src={adAmazon} width="100%" height="100%" alt="tissot ad" />
      </AdBanner>
      <ListElement className="w-100">
        {/* <Title fontFamily="Montserrat" fontSize="1.5rem" fontWeight="bold">
          Suggested
        </Title>
        <StyledLine>
          <StyledLineInside />
        </StyledLine> */}
        <AdBanner height="565px" width="300px" margin="0">
          <Image
            src={adSuggestedVertical}
            width="100%"
            height="100%"
            alt="tissot ad"
          />
        </AdBanner>
      </ListElement>
      <AdBanner height="600px" width="300px" margin="18px 0 18px 0">
        <Image
          src={adAmazonVertical}
          width="100%"
          height="100%"
          alt="tissot ad"
        />
      </AdBanner>
    </SideBar>
  );
};

export default withRouter(sideBar);
